<template>
  <div class="container--confirmar">
    <h2>Confirmar pedido de {{getCurrentClient.nombre}}</h2>
    <p class="pt-30">Numero de proveedores: {{proveedores.length}}</p>
    <ul class="contenedor--proveedores__resumen">
      <li class="confirmar-proveedores--card" v-for="(proveedor, index) in proveedores" :key="index">
        <p>{{proveedor.nombre}}</p>
        <ul>
          <li class="tabla--precio" v-for="(producto, idx) in productos(proveedor.id)" :key="idx">
            <p>{{producto.nombre}} {{producto.descripcion}}</p>
            <p>{{producto.costo}}</p>
          </li>
          <hr>
          <div class="tabla--precio">
            <p>Precio Tux</p>
            <p>{{precioTux(proveedor)}}</p>
          </div>
          <div class="tabla--precio">
            <p>Comisión Tux</p>
            <p>{{comisionTux(proveedor)}}</p>
          </div>
          <div class="tabla--precio">
            <p>Precio Publico</p>
            <p>{{precio(proveedor)}}</p>
          </div>
          <div class="seccion--aceptar" v-if="proveedor.recoger === undefined">
            <div class="pt-8">
              <label for="minutos" class="subtitulo">Tiempo de entrega del proveedor</label>
            </div>
            <input :id="index" name="minutos" type="phone" placeholder="minutos">
            <button @click="asignar( proveedor, index )">Asignar</button>
          </div>
        </ul>
      </li>

    </ul>
  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment-timezone';
moment.tz.setDefault('America/Mexico_City');

export default {
  name: 'Confirmar',
  props: ['id'],
  computed: {
    ...mapGetters([
      'getProductoPedido',
      'getProveedores',
      'getCurrentClient'
    ]),
    proveedores() {
      const prov = [];
      let setProveedores = new Set();
      const self = this;
      this.getProveedores.forEach( (proveedor) => {
        this.getProductoPedido.forEach( (pedido) => {
          if ( pedido.id === self.id && pedido.proveedor === proveedor.id ){
            setProveedores.add(proveedor)
          }
        })
      })
      return Array.from(setProveedores)
    }
  },
  methods: {
    ...mapActions([
      'setAsignarTiempo',
      'asignarTiempo'
    ]),
    asignar(proveedor, index) {
      console.log(proveedor);
      const minutos = document.getElementById(index).value;
      const recogerActual = moment(new Date()).toDate();
      const recoger = moment( new Date() ).add( minutos, 'minutes' ).toDate()

      let body = {
        id: index,
        cliente: this.getCurrentClient.numero,
        proveedor: proveedor.id,
        inicial: recogerActual,
        entrega: recoger,
      }
      console.log(this.getCurrentClient);
      console.log(body);
      this.asignarTiempo(body);
    },
    productos( proveedor ) {
      const prods = [];

      this.getProductoPedido.forEach( (producto) => {
        if ( producto.id === this.id && producto.proveedor === proveedor ) {
          prods.push(producto)
        }
      })

      return prods;
    },
    comisionTux(proveedor) {

      let suma = 0

      this.getProductoPedido.forEach( (producto) => {
        if ( producto.id === this.id && producto.proveedor === proveedor.id ){
          suma = suma + (producto.cantidad * producto.costo * (proveedor.comision / 100 ))
        }
      })
      return suma
    },
    precioTux(proveedor) {

      console.log(proveedor)
      let suma = 0

      this.getProductoPedido.forEach( (producto) => {
        if ( producto.id === this.id && producto.proveedor === proveedor.id ){
          suma = suma + (producto.cantidad * producto.costo * ( 1 - (proveedor.comision / 100 )) )
        }
      })
      return suma
    },
    precio(proveedor) {

      let suma = 0
      this.getProductoPedido.forEach( (producto) => {
        if ( producto.id === this.id && producto.proveedor === proveedor.id ){
          suma = suma + (producto.cantidad * producto.costo)
        }
      })
      return suma
    }
  }


}
</script>

<style lang="sass">
.container--confirmar
  height: 100%
  padding: 0 20px
  width: calc( 100% - 60px )
  .pt-30
    padding-top: 30px

  .contenedor--proveedores__resumen
    display: grid
    grid-template-columns: repeat(4, 1fr)
    grid-gap: 20px
    .confirmar-proveedores--card
      position: relative
      height: 320px
      width: 240px
      border: 1px solid #c0c0c0
      padding: 6px
      font-size: 14px
      .tabla--precio
        display: flex
        flex-direction: columns
        justify-content: space-between
.subtitulo
  font-size: 12px
  text-align: left
.seccion--aceptar
  height: 120px
  width: 100%
  position: absolute
  bottom: 10px
  input
    height: 30px
    padding: 0 10px
    margin-bottom: 6px
    border-bottom: 1px solid #b0b0b0
.pt-8
  padding-top: 8px
</style>
